import { Maybe } from '@plugins/shared/types';
import { isNullish } from '@plugins/shared/utils/assertFunctions';

export const interpolate = (
  translation: string,
  params?: Maybe<Record<string, Maybe<string | number>>>,
): string => {
  if (!params) return translation;
  let interpolatedTranslation = translation;
  Object.entries(params).forEach(([key, value]) => {
    if (isNullish(value)) return;
    const regex = new RegExp(String.raw`\{\{\s?${key}\s?\}\}`, 'g');
    interpolatedTranslation = interpolatedTranslation.replaceAll(
      regex,
      `${value}`,
    );
  });
  return interpolatedTranslation;
};
